import { Profile, User } from "stubminer-logic/dist";
import { getMe } from "../graphql/queries";
import { client } from "../App";

interface GetMeGraphqlReturn {
  data: {
    getMe: { user: User };
  };
}

interface RefreshMe {
  (
    setUser: (user: User) => void,
    setProfile: (profile: Profile) => void
  ): Promise<void>;
}

export const refreshMe: RefreshMe = async (setUser, setProfile) => {
  const { data } = (await client.graphql({
    query: getMe,
  })) as GetMeGraphqlReturn;
  console.log("refreshMe", { data });
  setUser(data.getMe.user);
};
